<template>
  <div
    class="lg:mx-auto md:mx-12 mx-6  shadow-lg overflow-hidden lg:max-w-none lg:flex
     border-vectric border-8
     rounded-t-2xl rounded-br-2xl
     bg-white
"
  >
    <div class="bg-white w-full lg:flex-shrink-1 md:p-10 p-6">
      <router-link :to="sessionUrl">
        <h3 class="text-lg md:text-xl font-bold text-gray-900 md:text-3xl">
          {{ session.title }}
        </h3>
      </router-link>
      <div class="md:flex mt-4">
        <p
          class="md:text-base text-sm leading-6 font-medium text-gray-900 mt-4 lg:mt-0"
        >
          {{ session.shortDescription }}
        </p>
      </div>

      <!--<div class="mt-4 md:w-2/3">
        <topic-grid :session="session" :color="topicColor"></topic-grid>
      </div>-->
      <div class="mt-10 md:w-2/3">
        <session-compatibility-block
          :session="session"
        ></session-compatibility-block>
      </div>
    </div>
    <div
      class="  text-center bg-white lg:w-1/4 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center md:p-10 p-6"
    >
      <img
        :src="previewImage"
        alt=""
        class="rounded-t-lg rounded-br-lg mx-auto "
      />

      <div
        v-if="false"
        class="mt-4 flex items-baseline justify-center text-xl md:text-3xl leading-none font-extrabold text-darkBlue"
      >
        <span> {{ friendlyStart.hours }} </span
        ><span v-if="friendlyStart.minute !== '00'"
          >:{{ friendlyStart.minute }}</span
        ><span>{{ friendlyStart.ampm }}</span>
        <span class="text-lg pl-2"> ({{ timezone }})</span>
      </div>
      <div v-if="session.watchStatus === 'IDLE'">
        <div class="inline-flex rounded-md mx-auto">
          <!--<div class="">
            <button
              type="button"
              @click="setReminder"
              class="inline-flex justify-center items-center px-5 py-3
              border-transparent text-sm leading-6  font-semibold  uppercase
                  focus:outline-none  transition ease-in-out duration-150"
              :class="{
                'text-cut2dPro': scheduledReminder,
                'text-aspire': !scheduledReminder
              }"
            >
              {{ reminderText }}
              <svg
                class="ml-3 -mr-1 h-5 w-5"
                :class="{ 'text-green border-green': scheduledReminder }"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                ></path>
              </svg>
            </button>
          </div>-->
        </div>
      </div>
      <div class="mt-6">
        <router-link :to="sessionUrl">
          <a
            class="items-center justify-center  px-2 md:px-2 xl:px-8 py-3 border border-transparent md:text-sm xl:text-lg uppercase tracking-tight  rounded-md bg-vectric focus:outline-none focus:shadow-outline transition duration-150 ease-in-out text-black font-bold"
          >
            {{ buttonText }}
          </a>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import {auth} from "../utils/firebase";
import {remindersCollection} from "../utils/firebase";
import TopicGrid from "./TopicGrid";
import SessionCompatibilityBlock from "./SessionCompatibilityBlock";
import sanityImageBuilder from "../utils/sanityImageBuilder";
import {
  EVENT_TIME_ZONE_LABEL,
  toFriendlyTime,
  toFriendlyTimeAMPMObj
} from "../utils/dateHelpers";
import {colorFromSession} from "../utils/colorFromSession";

export default {
  name: "SessionScheduleBlock",
  components: {
    SessionCompatibilityBlock
  },
  data() {
    return {
      scheduledReminder: false
    }
  },
  props: {
    session: null
  },
  computed: {
    previewImage() {
      return sanityImageBuilder
          .image(this.session.previewImage)
          .width(600)
          .height(600)
          .url();
    },

    friendlyStart() {
      return toFriendlyTimeAMPMObj(this.session.startTime)
    },
    friendlyEnd() {
      return toFriendlyTime(this.session.endTime);
    },
    sessionUrl() {
      return "/session/" + this.session.slug.current;
    },
    timezone() {
      return EVENT_TIME_ZONE_LABEL;
    },
    buttonText() {
      switch (this.session.watchStatus) {
        case "IDLE":
          return "More Details";
        case "COMPLETE":
          return "Watch Again";
        default:
          return "More Details";
      }
    },
    topicColor() {
      return colorFromSession(this.session);
    },
  },
  mounted() {
  },
  methods: {
  },
  beforeDestroy() {
    if (this.unsubscribeReminder) {
      this.unsubscribeReminder();
    }
  }
}
</script>

<style scoped></style>
